import { SebbiaLockup } from "@/components/brand/SebbiaLogo";
import { EVENTOS, track } from "@/lib/captacion";
import { LEMA, NAV_LINKS, whatsappUrl } from "./content";

const enlace = "text-sm text-slate-600 transition-colors duration-200 hover:text-indigo-700";

export const LandingFooter = () => (
  <footer className="border-t border-slate-200 bg-slate-50" data-testid="landing-footer">
    <div className="mx-auto grid max-w-6xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-[1.5fr_1fr_1fr_1fr]">
      <div>
        <SebbiaLockup size="sm" wordClassName="text-slate-900" as="span" />
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
          Administración de arriendos para corredoras y administradores de propiedades en Chile.
        </p>
        <p className="mt-3 text-sm font-semibold text-indigo-700">{LEMA}</p>
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">Producto</p>
        <ul className="mt-4 space-y-2.5">
          {NAV_LINKS.map((l) => <li key={l.href}><a href={l.href} className={enlace}>{l.label}</a></li>)}
        </ul>
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">Contacto</p>
        <ul className="mt-4 space-y-2.5">
          <li><a href="#demo" className={enlace}>Agenda una demo</a></li>
          <li>
            <a
              href={whatsappUrl()}
              target="_blank"
              rel="noopener noreferrer"
              className={enlace}
              onClick={() => track(EVENTOS.contacto, { canal: "whatsapp", seccion: "footer" })}
            >
              WhatsApp
            </a>
          </li>
          <li><a href="/login" className={enlace}>Ingresar a SEBBIA</a></li>
        </ul>
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">Legal</p>
        <ul className="mt-4 space-y-2.5">
          <li><a href="/terminos" className={enlace}>Términos de uso</a></li>
          <li><a href="/privacidad" className={enlace}>Política de privacidad</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-slate-200">
      <p className="mx-auto max-w-6xl px-4 py-6 text-xs text-slate-400 sm:px-6">© {new Date().getFullYear()} SEBBIA. Todos los derechos reservados.</p>
    </div>
  </footer>
);
